export const QA_SAVE_WORKER_MESSAGE_TYPES = Object.freeze({
    START: "start",
    PAGE: "page",
    ROW: "row",
    CELLS: "cells",
    SERIALIZE: "serialize",
});

export function cloneFillAndSerializeQaData(qaData) {
    const clonedData = JSON.parse(JSON.stringify(qaData));

    for (let page = 0; page < clonedData.length; page += 1) {
        for (let row = 0; row < clonedData[page].length; row += 1) {
            for (let column = 0; column < clonedData[page][row].length; column += 1) {
                if (
                    clonedData[page][row][column] === null ||
                    clonedData[page][row][column] === undefined
                ) {
                    clonedData[page][row][column] = { value: "" };
                }
            }
        }
    }

    return JSON.stringify(clonedData);
}

function isNonNegativeInteger(value) {
    return Number.isInteger(value) && value >= 0;
}

export function createQaSaveWorkerMessageHandler(postMessage) {
    let activeRequest;

    const sendError = (requestId, error) => {
        activeRequest = undefined;
        postMessage({
            requestId,
            errorCode: error?.name || "SERIALIZATION_FAILED",
            errorMessage: error?.message || "QA serialization failed",
        });
    };

    return (event) => {
        const message = event?.data;
        const requestId = message?.requestId;
        if (!requestId) return;

        try {
            if (message.type === QA_SAVE_WORKER_MESSAGE_TYPES.START) {
                if (!isNonNegativeInteger(message.pageCount)) {
                    throw new TypeError("Invalid QA page count");
                }
                activeRequest = {
                    requestId,
                    pages: new Array(message.pageCount),
                };
                return;
            }

            if (!activeRequest || activeRequest.requestId !== requestId) return;

            if (message.type === QA_SAVE_WORKER_MESSAGE_TYPES.PAGE) {
                if (
                    !isNonNegativeInteger(message.pageIndex) ||
                    message.pageIndex >= activeRequest.pages.length ||
                    !isNonNegativeInteger(message.rowCount)
                ) {
                    throw new TypeError("Invalid QA page details");
                }
                activeRequest.pages[message.pageIndex] = new Array(message.rowCount);
                return;
            }

            if (message.type === QA_SAVE_WORKER_MESSAGE_TYPES.ROW) {
                const page = activeRequest.pages[message.pageIndex];
                if (
                    !Array.isArray(page) ||
                    !isNonNegativeInteger(message.rowIndex) ||
                    message.rowIndex >= page.length ||
                    !isNonNegativeInteger(message.cellCount)
                ) {
                    throw new TypeError("Invalid QA row details");
                }
                page[message.rowIndex] = new Array(message.cellCount);
                return;
            }

            if (message.type === QA_SAVE_WORKER_MESSAGE_TYPES.CELLS) {
                const row = activeRequest.pages[message.pageIndex]?.[message.rowIndex];
                if (
                    !Array.isArray(row) ||
                    !isNonNegativeInteger(message.cellStart) ||
                    !Array.isArray(message.cells) ||
                    message.cellStart + message.cells.length > row.length
                ) {
                    throw new TypeError("Invalid QA cell batch");
                }
                for (let cellOffset = 0; cellOffset < message.cells.length; cellOffset += 1) {
                    const cell = message.cells[cellOffset];
                    row[message.cellStart + cellOffset] = cell === null || cell === undefined
                        ? { value: "" }
                        : cell;
                }
                return;
            }

            if (message.type !== QA_SAVE_WORKER_MESSAGE_TYPES.SERIALIZE) {
                throw new TypeError("Invalid QA worker message");
            }

            const json = JSON.stringify(activeRequest.pages);
            activeRequest = undefined;
            postMessage({ requestId, json });
        } catch (error) {
            sendError(requestId, error);
        }
    };
}
